import {
  TextField,
  Box,
  IconButton,
  useTheme,
  MenuItem,
  Typography,
  Menu,
  Tooltip,
  Chip,
  LinearProgress,
  Checkbox,
  FormControlLabel,
  Button,
  Stack,
  FormGroup,
  FormControl,
  InputLabel,
  Select
} from "@mui/material";
import { useEffect } from "react";
import DoneIcon from "@mui/icons-material/Done";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import Swal from "sweetalert2";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RedoIcon from "@mui/icons-material/Redo";
import UndoIcon from "@mui/icons-material/Undo";
import BlockIcon from "@mui/icons-material/Block";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import LockResetIcon from "@mui/icons-material/LockReset";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
// import MatxCustomizer from "./Mailpdf";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import BalanceIcon from "@mui/icons-material/Balance";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { tokens, ColorModeContext } from "../../Theme";
import { useProSidebar } from "react-pro-sidebar";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { fetchListview, setEmployeeID, setFromDate, setToDate } from "../../store/reducers/Listviewapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Link } from "react-router-dom";
import { useContext } from "react";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useState } from "react";
import { fnCsvFileUpload } from "../../store/reducers/Imguploadreducer";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { screenRightsData } from "../../store/reducers/screenRightsreducer";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import PauseCircleOutlinedIcon from "@mui/icons-material/PauseCircleOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import NotStartedOutlinedIcon from "@mui/icons-material/NotStartedOutlined";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import EmailIcon from "@mui/icons-material/Email";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../ui-components/global/utils";
import { fetchExplorelitview } from "../../store/reducers/Explorelitviewapireducer";
import { CheckinAutocomplete, Employeeautocomplete, MultiFormikOptimizedAutocomplete } from "../../ui-components/global/Autocomplete";
import FlagIcon from "@mui/icons-material/Flag";
import AddTaskIcon from "@mui/icons-material/AddTask";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TodayIcon from "@mui/icons-material/Today";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import axios from "axios";
import { AttachFile, Psychology } from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import QuizIcon from "@mui/icons-material/Quiz";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import { Formik } from "formik";
import toast from "react-hot-toast";
import { resetTrackingData } from "../../store/reducers/Formapireducer";
import CancelIcon from "@mui/icons-material/Cancel";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AttendancePDF from "../reports/AttendancePdf";
import OnsitesummaryPDF from "../reports/Summaryonsite";
import OHsummaryPDF from "../reports/Overheadsummary";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { getConfig } from "../../config";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import InvpaymentPDF from "../reports/Invpaymentdetailpdf";
import ClearIcon from "@mui/icons-material/Clear";
import { InputAdornment } from "@mui/material";
import { BlobProvider } from "@react-pdf/renderer";
import RateReviewOutlinedIcon from "@mui/icons-material/RateReviewOutlined";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import DatasetLinkedIcon from '@mui/icons-material/DatasetLinked';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';

const Listview = () => {
  const navigate = useNavigate();
  const colorMode = useContext(ColorModeContext);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const YearFlag = sessionStorage.getItem("YearFlag");
  var currentPage = parseInt(sessionStorage.getItem("currentPage"));
  const location = useLocation();
  const rowData = location.state || {};
  console.log(rowData, "--rowData state");

  const dispatch = useDispatch();
  const params = useParams();
  var accessID = params.accessID;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [pageSize, setPageSize] = React.useState(20);
  const [page, setPage] = React.useState(currentPage || 0);
  const [collapse, setcollapse] = React.useState(false);
  var invoice;
  const mailData = useSelector((state) => state.listviewApi.mailData);
  const EMPID = sessionStorage.getItem("EmpId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const open = useSelector((state) => state.listviewApi.mailOpen);

  var screenName = params.screenName;

  const year = sessionStorage.getItem("year");
  const listViewData = useSelector((state) => state.listviewApi.rowData);
  console.log(listViewData, "listViewData");
  const loading = useSelector((state) => state.listviewApi.loading);
  const { UGA_ADD, UGA_VIEW, UGA_MOD, UGA_DEL, UGA_PROCESS, UGA_PRINT } =
    useSelector((state) => state.screenRights.data);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [showMore, setShowMore] = React.useState(false);
  const currentMonthNumber = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  const currentDate = new Date().toISOString().split("T")[0];

  const ManagerEmpIDCS = sessionStorage.getItem("ManagerEmpIDCS");
  const EMP_TRAINBY = sessionStorage.getItem("EMP_TRAINBY");

  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  const is002Subscription = SubscriptionCode.endsWith("002");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");

  const taskTypeLabels = {
    H: "Homework",
    P: "Time Table"
  };

  var screenName_V1;

  if (accessID === "TR123") {
    screenName_V1 = is003Subscription ? "In Time" : params.screenName;
  }
  else if (accessID === "TR124") {
    screenName_V1 = is003Subscription ? "Out Time" : params.screenName;
  }
  else if (accessID === "TR354") {
    screenName_V1 = is003Subscription ? "Daily Activities" : params.screenName;
  }
  // else if(accessID === "TR208"){
  //     screenName_V1 = is003Subscription ? "Leave Request" : params.screenName;
  // }
  // else if(accessID === "TR242"){
  //     screenName_V1 = is003Subscription ? "Official Duty" : params.screenName;
  // }
  // else if(accessID === "TR216"){
  //     screenName_V1 = is003Subscription ? "Extra Hours" : params.screenName;
  // }
  // else if(accessID === "TR219"){
  //     screenName_V1 = is003Subscription ? "Attendance Correction" : params.screenName;
  // }
  // else if(accessID === "TR160"){
  //     screenName_V1 = is003Subscription ? "Advance Salary" : params.screenName;
  // }
  // else if(accessID === "TR331"){
  //     screenName_V1 = is003Subscription ? "Billing / Fees" : params.screenName;
  // }
  // else if(accessID === "TR133"){
  //     screenName_V1 = is003Subscription ? "Standard" : params.screenName;
  // }
  else {
    screenName_V1 = params.screenName;
  }
  const FirstLevelSub =
    JSON.parse(sessionStorage.getItem("FirstLevelSub")) || [];
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, []);
  const formatDateTime = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`
    );
  };

  const [empData, setempData] = useState(() => {
    const empId = sessionStorage.getItem("EmployeeID");
    const empName = sessionStorage.getItem("EmployeeName");

    // ✅ If UseCurrentEmp is Y → clear the field
    const isSelf = sessionStorage.getItem("UseCurrentEmp") === "Y";
    if (isSelf) return null;

    return empId && empName ? { RecordID: empId, Name: empName } : null;
  });

  const [useCurrentEmp, setUseCurrentEmp] = useState(() => {
    const storedSelf = sessionStorage.getItem("UseCurrentEmp");
    return storedSelf ? storedSelf === "Y" : false; // default false if not set
  });

  const handleSelectionEmployeeChange = (newValue) => {
    if (newValue) {
      // ✅ store selected employee in state & session
      setempData(newValue);
      sessionStorage.setItem("SelectedEmployeeID", newValue.RecordID);
      sessionStorage.setItem("EmployeeName", newValue.Name);
      sessionStorage.setItem("UseCurrentEmp", "N"); // override self
    } else {
      // ✅ clear state & session if no value
      setempData(null);
      sessionStorage.removeItem("SelectedEmployeeID");
      sessionStorage.removeItem("EmployeeName");
    }

    setUseCurrentEmp(false);
  };


  const listViewcolumn = useSelector((state) => state.listviewApi.columnData);
  const [selectedFile, setSelectedFile] = useState();
  const [uploadFile, setUploadFile] = useState();
  // const compID = sessionStorage.getItem("compID");
  const EmpId = sessionStorage.getItem("EmpId");
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0];
  const YearRecorid = sessionStorage.getItem("YearRecorid");
  const companyID = sessionStorage.getItem("companyId");
  const isManager = sessionStorage.getItem("isManager");
  const isprojectmanager = sessionStorage.getItem("isprojectmanager");


  // const handleApply = async () => {
  //   let employeeID = null;

  //   if (useCurrentEmp) {
  //     employeeID = EmpId; // From context or props
  //   } else if (empData?.RecordID) {
  //     employeeID = empData.RecordID;
  //   }

  //   if (employeeID) {
  //     const res = await dispatch(
  //       fetchListview(
  //         "TR264",
  //         "Onsite Activities",
  //         `EmployeeID='${employeeID}'`,
  //         ""
  //       )
  //     );
  //   } else {
  //     console.warn("No employee selected");
  //   }
  // };
  const handleApply = async () => {
    let employeeID = null;
    let employeeName = null;

    if (useCurrentEmp) {
      // ✅ Use logged-in EmpId but don't set any name in empData
      employeeID = EmpId;
      employeeName = null;
      setempData(null);         // clear field
    } else if (empData?.RecordID) {
      employeeID = empData.RecordID;
      employeeName = empData.Name;
    }

    if (employeeID) {
      // ✅ Store in session
      sessionStorage.setItem("EmployeeID", employeeID);
      sessionStorage.setItem("EmployeeName", employeeName || ""); // empty string when self
      sessionStorage.setItem("UseCurrentEmp", useCurrentEmp ? "Y" : "N");

      await dispatch(
        fetchListview(
          "TR293",
          "Onsite Activities",
          `CompanyID='${companyID}' AND EmployeeID='${employeeID}'`,
          ""
        )
      );
    } else {
      console.warn("No employee selected");
    }
  };


  const fromDate = useSelector((state) => state.listviewApi.fromDate);
  console.log("🚀 ~ Listview ~ fromDate:", fromDate)
  const toDate = useSelector((state) => state.listviewApi.toDate);
  const restoreempid = useSelector((state) => state.listviewApi.EmployeeID);
  const [selectedDate, setSelectedDate] = useState(toDate);
  const [fromselectedDate, setfromSelectedDate] = useState(fromDate);
  const statusCodeMap = {
    Applied: "AL",
    Query: "QR",
    Approved: "AP",
  };
  const TaskCodeMap = {
    Applied: "AL",
    Query: "QR",
    Approved: "AP",
  };

  const formattedDate2 = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  //FOR HEADER AND FOOTER pdf
  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  console.log("HeaderImg", HeaderImg, FooterImg);


  React.useEffect(() => {
    // ✅ restore checkbox from session
    // const storedSelf = sessionStorage.getItem("UseCurrentEmp");
    // if (storedSelf !== null) {
    //   setUseCurrentEmp(storedSelf === "Y");
    // }

    // let filterCondition = "";

    // if (accessID === "TR264") {
    //   const sessionEmpID = sessionStorage.getItem("SelectedEmployeeID");

    //   if (sessionEmpID) {
    //     filterCondition = `CompanyID='${companyID}' AND EmployeeID='${sessionEmpID}'`;
    //     // filterCondition = `CompanyID='${companyID}' AND EmployeeID='102'`;
    //   } else {
    //     filterCondition = `CompanyID='${companyID}' AND EmployeeID='${EmpId}'`; // default
    //     // filterCondition = `CompanyID='${companyID}' AND EmployeeID='102'`;
    //   }
    // }
    const storedSelf = sessionStorage.getItem("UseCurrentEmp");
    if (storedSelf !== null) {
      setUseCurrentEmp(storedSelf === "Y");
    }

    let filterCondition = "";

    // ✅ Try loading saved filters
    // const storedFilters = sessionStorage.getItem("TR264_Filters");
    const storedFilters = sessionStorage.getItem("TR293_Filters");

    // if (accessID === "TR264") {
    if (accessID === "TR293") {
      if (storedFilters) {
        // parse stored filters and rebuild condition
        const values = JSON.parse(storedFilters);
        const conditions = [];
        const selectedStatusArr = values.Status.split(",");
        const statusCodes = selectedStatusArr
          .map((s) => statusCodeMap[s])
          .join(",");
        if (values.fromDate && values.toDate) {
          // const fromDate = formattedDate2(values.fromDate);
          // const toDate = formattedDate2(values.toDate);
          conditions.push(`FilterDate BETWEEN '${values.fromDate}' AND '${values.toDate}'`);
        }

        // if (values.Status) {
        //   conditions.push(`AppStatus='${statusCodes}'`);
        // }
        if (values.Status) {
          conditions.push(`AppStatus='${values.Status}'`);
        }

        if (values.Employee?.RecordID) {
          conditions.push(`EmployeeID IN (${values.Employee.RecordID})`);
        } else if (values.self) {
          conditions.push(`EmployeeID='${EmpId}'`);
        }

        if (values.project?.length > 0) {
          const projIds = values.project.map((p) => `'${p.RecordID}'`).join(",");
          conditions.push(`ProjectID IN (${projIds})`);
        }
        if (values.overhead?.length > 0) {
          const OHIds = values.overhead.map((p) => `'${p.RecordID}'`).join(",");
          conditions.push(`HeaderOverheadID IN (${OHIds})`);
        }
        // if (values.overhead?.RecordID) {
        //   conditions.push(`OverheadID='${values.overhead.RecordID}'`);
        // }

        conditions.push(`CompanyID='${companyID}'`);

        filterCondition = conditions.join(" AND ");
      } else {
        // ✅ No session filters → apply default
        const sessionEmpID = sessionStorage.getItem("SelectedEmployeeID");
        if (sessionEmpID) {
          filterCondition = `CompanyID='${companyID}' AND EmployeeID='${sessionEmpID}'`;
        } else {
          filterCondition = `CompanyID='${companyID}' AND EmployeeID='${EmpId}'`;
        }
      }
    }
    if (accessID !== "TR277") {
      dispatch(
        fetchListview(
          accessID,
          screenName,
          filterCondition,
          "",
          companyID
        )
      );
    }
    // if (accessID == "TR264") {
    if (accessID == "TR293") {
      dispatch(
        fetchListview(
          "TR293",
          screenName,
          filterCondition,
          "",
          companyID
        )
      );
    }
    setSelectedDate(formattedDate);
    setfromSelectedDate(formattedDate);
  }, [location.key]);


  function filterByID(item) {
    if (item.hide !== true) {
      return true;
    }
  }

  // const columnShow = React.useMemo(
  //   () =>
  //     listViewcolumn.filter(filterByID)
  //       ? [
  //        {
  //               field: "slno",
  //               headerName: "SL#",
  //               width: 50,
  //               sortable: false,
  //               filterable: false,
  //               valueGetter: (params) =>
  //                 `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
  //             },
  //         ,
  //           ...listViewcolumn.filter(filterByID),
  //         ]
  //       :  [],
  //   [listViewcolumn]
  // );

  //WORKING AS OF 17/02/2026
  const columnShow = React.useMemo(
    () =>
      listViewcolumn.filter(filterByID)
        ? [
          {
            field: "slno",
            headerName: "SL#",
            width: 50,
            sortable: false,
            filterable: false,
            valueGetter: (params) =>
              page * pageSize +
              params.api.getRowIndexRelativeToVisibleRows(params.id) +
              1,
          },
          ...listViewcolumn.filter(filterByID),
        ]
        : [],
    [listViewcolumn, page, pageSize] // include page & pageSize as deps
  );
  const handleResetFilters = (setFieldValue) => {
    // 1. Remove all TR132 related session values
    const keys = [
      "FromDate",
      "ToDate",
      "EmployeeID",
      "EmployeeName",
      "TR132_project",
      "TR132_Milestone",
      "TR132_self",
      "TR132_manager",
      "TR132_sprint",
      "TR132_assigned",
      "TR132_scheduled",
      "TR132_inprogress",
      "TR132_completed",
      "TR132_approved",
      "TR132_query",
      "TR132_TaskType",
      "TR132_Teacher"
    ];

    keys.forEach((key) => sessionStorage.removeItem(key));

    // 2. Reset Formik fields
    setFieldValue("fromdate", "");
    setFieldValue("date", "");

    // Autocomplete
    setFieldValue("project", []);
    setFieldValue("Milestone", []);
    // Task Source
    setFieldValue("Teacher", false);
    setFieldValue("self", false);
    setFieldValue("manager", false);
    setFieldValue("sprint", false);
    setFieldValue("TaskType", "");
    // Status checkboxes
    setFieldValue("assigned", false);
    setFieldValue("scheduled", false);
    setFieldValue("inprogress", false);
    setFieldValue("completed", false);
    setFieldValue("approved", false);
    setFieldValue("query", false);
  };


  const handleResetFiltersTR354 = (setFieldValue) => {
    // 1. Remove all TR132 related session values
    const keys = [
      "FromDate",
      "ToDate",
      "EmployeeID",
      "EmployeeName",
      "TR354_project",
      "TR354_Milestone",
      "TR354_self",
      "TR354_manager",
      "TR354_sprint",
      "TR354_assigned",
      "TR354_scheduled",
      "TR354_inprogress",
      "TR354_completed",
      "TR354_approved",
      "TR354_query",
      "TR354_TaskType",
      "TR354_Teacher"
    ];

    keys.forEach((key) => sessionStorage.removeItem(key));

    // 2. Reset Formik fields
    setFieldValue("fromdate", "");
    setFieldValue("date", "");

    // Autocomplete
    // ✅ IMPORTANT FIX
    setSelectedEmp(null);
    setFieldValue("project", []);
    setFieldValue("Milestone", []);
    // Task Source
    setFieldValue("Teacher", false);
    setFieldValue("self", false);
    setFieldValue("manager", false);
    setFieldValue("sprint", false);
    setFieldValue("TaskType", "");
    // Status checkboxes
    setFieldValue("assigned", false);
    setFieldValue("scheduled", false);
    setFieldValue("inprogress", false);
    setFieldValue("completed", false);
    setFieldValue("approved", false);
    setFieldValue("query", false);
  };
  const rows = React.useMemo(() => {
    return listViewData;
  }, [listViewData]);
  //   const [selectedEmp, setSelectedEmp] = useState({
  //     RecordID:sessionStorage.getItem("EmpId"),Name:sessionStorage.getItem("EmployeeName")
  //   });
  // console.log("SELECTEMPLOYEE",selectedEmp);
  // const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedEmp, setSelectedEmp] = useState(() => {
    const empId = sessionStorage.getItem("EmployeeID");
    const empName = sessionStorage.getItem("EmployeeName");
    return empId && empName ? { RecordID: empId, Name: empName } : null;
  });
  /*****************File upload************ */
  const compID = rows?.[0]?.CompanyID || sessionStorage.getItem("compID");

  const changeHandler = async (event) => {
    setSelectedFile(event.target.files[0]);

    console.log(event.target.files[0]);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "csv");

    const fileData = await dispatch(fnCsvFileUpload(formData));

    console.log("fileData" + JSON.stringify(fileData));
    setUploadFile(fileData.payload.apiResponse);
  };
  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR027/Employees");
        }
      } else {
        return;
      }
    });
  };

  function CustomToolbar(listViewData) {
    function doesArrayContainNegative() {
      for (var arr of listViewData) {
        if (arr.Shortage < 0) return true;
      }
      return false;
    }
    return (
      <GridToolbarContainer
        key={location.key}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {/* {broken && !rtl && (
          <IconButton
            sx={{ margin: "0 6 0 2" }}
            onClick={() => toggleSidebar()}
          >
            <MenuOutlinedIcon />
          </IconButton>
        )}
        <Box sx={{ display: "flex", 
          flexDirection: "row",
          justifyContent: "flex-start !important", // force override
    width: "100%",
           }}>
          <Typography variant="h3">{screenName}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap", // allow wrapping on very small screens
            gap: 2,
            width: "100%",
            alignItems: "center",
          }}
        > */}
        {broken && !rtl && (
          <IconButton onClick={toggleSidebar}>
            <MenuOutlinedIcon />
          </IconButton>
        )}

        <Typography variant="h3" noWrap>
          {/* {screenName} */}
          {screenName_V1}
        </Typography>

        {/* RIGHT SIDE */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            marginLeft: "auto", // 👈 pushes everything to right
            flexWrap: "nowrap",
          }}
        >
          {/* Left side fields */}
          {/* <Box
            sx={{
              display: "flex",
              flexWrap: "wrap", // allows fields to stack on small screens
              gap: 2,
              marginBottom: 2,
              flex: "1 1 auto", // grow/shrink with container
              minWidth: 0, // prevent overflow
            }}
          >
            {accessID === "TR132" ? (
              <>
                <TextField
                  name="fromdate"
                  type="date"
                  id="fromdate"
                  label="From Date"
                  variant="standard"
                  value={fromDate || ""}
                  onChange={(e) => {
                    const newDate2 = e.target.value;

                    // Save in Redux
                    dispatch(setFromDate(newDate2));

                    // Save in sessionStorage
                    sessionStorage.setItem("FromDate", newDate2);

                    if (selectedDate) {
                      dispatch(
                        fetchListview(
                          "TR132",
                          "Scrum Task",
                          `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${newDate2}' AND '${toDate}' AND CompanyID ='${companyID}'`,
                          ""
                        )
                      );
                    }
                  }}
                  focused
                  required
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ max: new Date().toISOString().split("T")[0] }}
                  sx={{ width: 250, marginLeft: isManager != 1 ? "100px" : 0 }}
                />

                <TextField
                  name="date"
                  type="date"
                  id="date"
                  label="To Date"
                  variant="standard"
                  value={toDate || ""}
                  onChange={(e) => {
                    const newDate = e.target.value;

                    // Save in Redux
                    dispatch(setToDate(newDate));

                    // Save in sessionStorage
                    sessionStorage.setItem("ToDate", newDate);

                    dispatch(
                      fetchListview(
                        "TR132",
                        "Scrum Task",
                        `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${newDate}' AND CompanyID ='${companyID}'`,
                        ""
                      )
                    );
                  }}
                  focused
                  required
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ max: new Date().toISOString().split("T")[0] }}
                  sx={{ width: 250, marginLeft: isManager != 1 ? "100px" : 0 }}
                />
              </>
            ) : (
              false
            )}


            {isManager == 1 && accessID === "TR132" ? (
              <Employeeautocomplete
                sx={{ width: 250 }}
                name="empName"
                label="Employee"
                id="empName"
                value={selectedEmp}   // stays null initially
                // onChange={(newValue) => {
                //   if (newValue) {
                //     setSelectedEmp(newValue);
                //     const EmpId = newValue.RecordID;

                //     // Save in Redux
                //     dispatch(setEmployeeID(EmpId));

                //     // Save in sessionStorage (just for debugging/tracking)
                //     sessionStorage.setItem("EmployeeID", EmpId);
                //     sessionStorage.setItem("EmployeeName", newValue.Name);

                //     console.log(newValue.Name, "--selected EmpName");

                //     dispatch(
                //       fetchListview(
                //         "TR132",
                //         "Scrum Task",
                //         `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${toDate}'`,
                //         ""
                //       )
                //     );
                //   } else {
                //     // If cleared, reset state + remove session storage
                //     setSelectedEmp(null);
                //     sessionStorage.removeItem("EmployeeID");
                //     sessionStorage.removeItem("EmployeeName");
                //     dispatch(setEmployeeID(""));
                //   }
                // }}
                onChange={(newValue) => {
                  if (newValue) {
                    setSelectedEmp(newValue);
                    const EmpId = newValue.RecordID;

                    // Save in Redux
                    dispatch(setEmployeeID(EmpId));

                    // Save in sessionStorage
                    sessionStorage.setItem("EmployeeID", EmpId);
                    sessionStorage.setItem("EmployeeName", newValue.Name);

                    console.log(newValue.Name, "--selected EmpName");

                    // Fetch with new employee
                    dispatch(
                      fetchListview(
                        "TR132",
                        "Scrum Task",
                        `EmployeesID='${EmpId}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${toDate}' AND CompanyID ='${companyID}'`,
                        ""
                      )
                    );
                  } else {
                    // If cleared
                    setSelectedEmp(null);

                    // Remove from sessionStorage
                    sessionStorage.removeItem("EmployeeID");
                    sessionStorage.removeItem("EmployeeName");

                    // Reset Redux
                    dispatch(setEmployeeID(""));

                    console.log("Resetting to default EMPID");

                    // Fetch again with default EMPID
                    dispatch(
                      fetchListview(
                        "TR132",
                        "Scrum Task",
                        `EmployeesID='${EMPID}' AND DAILYTASKDATE BETWEEN '${fromDate}' AND '${toDate}' AND CompanyID ='${companyID}'`,
                        ""
                      )
                    );
                  }
                }}

                url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
              />
            ) : null}
          </Box> */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              flexShrink: 0, // prevent shrinking
              marginLeft: "auto", // push to right
            }}
          >
            {accessID === "TR293" || accessID === "TR132" || accessID === "TR331" || accessID === "TR354" || accessID === "TR366" ? (
              <IconButton onClick={() => setShowMore((prev) => !prev)}>
                {showMore ? (
                  <Tooltip title="Close">
                    <FilterAltOutlinedIcon />
                  </Tooltip>
                ) : (
                  <Tooltip title="Open">
                    <FilterAltOutlinedIcon />
                  </Tooltip>
                )}
              </IconButton>
            ) : (
              false
            )}
            {accessID == "TR331" ? (
              <Tooltip arrow title="Analytics">
                <IconButton>
                  <AnalyticsIcon
                    onClick={() => {
                      navigate(`./Invoice/Analytics`, {
                        state: {
                          ...rowData,
                        },
                      });
                    }}
                  />
                </IconButton>
              </Tooltip>
            ) : (
              false
            )}


            <GridToolbarQuickFilter key={accessID} />

            {accessID == "TR002" ? (
              <Tooltip arrow title="Product Tracking">
                <AssessmentIcon
                  sx={{ marginTop: "10px" }}
                  color="primary"
                  onClick={() => {
                    navigate(
                      "/Apps/TR200/Editproducttracking/EditProduct Tracking/1/A"
                    );
                  }}
                />
              </Tooltip>
            ) : (
              false
            )}

            {accessID == "TR159" ||
              accessID == "TR216" ||
              accessID == "TR132" ||
              accessID == "TR354" ||
              accessID == "TR219" ||
              accessID == "TR266" ||
              accessID == "TR242" ||
              accessID == "TR365" ||
              accessID == "TR208" ||
              accessID == "TR160" ||
              accessID == "TR086" ||
              accessID == "TR271" ||
              accessID == "TR391"
              // (accessID === "TR133" &&
              //   isManager == 0 &&
              //   isprojectmanager == "Y") 
              ? (
                <Tooltip arrow title="Add">
                  <IconButton>
                    <AddOutlinedIcon
                      onClick={() => {
                        navigate(`./Edit${screenName}/-1/A`, {
                          state: {
                            ...rowData,
                            CustomerID: "-1",
                            ProductID: "-1",
                            BomID: "-1",
                            CompanyID: compID,
                          },
                        });
                      }}
                    />
                  </IconButton>
                </Tooltip>
              ) : (
                false
              )}
            {accessID == "TR365" ? (
              <Tooltip arrow title="Analytics">
                <IconButton>
                  <AnalyticsIcon
                    onClick={() => {
                      navigate(`./HomeWork/Analytics`, {
                        state: {
                          ...rowData,
                        },
                      });
                    }}
                  />
                </IconButton>
              </Tooltip>
            ) : (
              false
            )}
            {accessID === "TR332" && (
              <Tooltip arrow title="Add">
                <IconButton>
                  <AddOutlinedIcon
                    onClick={() => {
                      navigate(`/Apps/Secondarylistview/TR332/Payment/${params.row.RecordID}/${params.row.EmployeeID}/-1/A`, {
                        state: {
                          Employee: params.row.Employee,
                          Project: params.row.Project,
                          ProjectID: params.row.ProjectID
                        },
                      });
                    }}
                  />
                </IconButton>
              </Tooltip>
            )}


            {accessID == "TR043" ? (
              <Tooltip arrow title="Product Line Chart">
                <AssessmentIcon
                  sx={{ marginTop: "10px" }}
                  color="primary"
                  onClick={() => {
                    navigate(`/Apps/product-analysis/1/E`);
                  }}
                />
              </Tooltip>
            ) : (
              false
            )}

            {accessID == "TR064" ? (
              <Tooltip arrow title="Excel">
                <IconButton
                  size="large"
                  color="primary"
                  aria-label="upload picture"
                  component="label"
                >
                  <input
                    hidden
                    accept="all/*"
                    type="file"
                    onChange={changeHandler}
                  />
                  <FileUploadIcon />
                </IconButton>
              </Tooltip>
            ) : (
              false
            )}
            {accessID == "TR059" ? (
              <Tooltip arrow title="Report">
                <AssessmentIcon
                  sx={{ marginTop: "10px" }}
                  color="primary"
                  onClick={() => {
                    navigate("/Apps/TR100/Editreport/EditReport/1/A");
                  }}
                />
              </Tooltip>
            ) : (
              false
            )}


            <GridToolbarExport
              printOptions={{ disableToolbarButton: true }}
              csvOptions={{
                fileName: `${screenName}`,
              }}
            />

            <Tooltip arrow title="Logout">
              <IconButton onClick={() => fnLogOut("Logout")} color="error">
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {/* <GridToolbarQuickFilter key={accessID} />
          {accessID == "TR002" ? (
            <Tooltip arrow title="Product Tracking">
              <AssessmentIcon
                sx={{ marginTop: "10px" }}
                color="primary"
                onClick={() => {
                  navigate(
                    "/Apps/TR200/Editproducttracking/EditProduct Tracking/1/A"
                  );
                }}
              />
            </Tooltip>
          ) : (
            false
          )}

          {accessID == "TR159" ||
          accessID == "TR216" ||
          accessID == "TR132" ||
          accessID == "TR219" ||
          accessID == "TR266" ||
          accessID == "TR242" ||
          accessID == "TR208" ||
          accessID == "TR160" ||
          accessID == "TR086" ||
          accessID == "TR271" ||
          (accessID === "TR133" &&
            isManager == 0 &&
            isprojectmanager == "Y") ? (
            <Tooltip arrow title="Add">
              <IconButton>
                <AddOutlinedIcon
                  onClick={() => {
                    navigate(`./Edit${screenName}/-1/A`, {
                      state: {
                        CustomerID: "-1",
                        ProductID: "-1",
                        BomID: "-1",
                      },
                    });
                  }}
                />
              </IconButton>
            </Tooltip>
          ) : (
            false
          )}

          {accessID == "TR043" ? (
            <Tooltip arrow title="Product Line Chart">
              <AssessmentIcon
                sx={{ marginTop: "10px" }}
                color="primary"
                onClick={() => {
                  navigate(`/Apps/product-analysis/1/E`);
                }}
              />
            </Tooltip>
          ) : (
            false
          )}

          {accessID == "TR064" ? (
            <Tooltip arrow title="Excel">
              <IconButton
                size="large"
                color="primary"
                aria-label="upload picture"
                component="label"
              >
                <input
                  hidden
                  accept="all/*"
                  type="file"
                  onChange={changeHandler}
                />
                <FileUploadIcon />
              </IconButton>
            </Tooltip>
          ) : (
            false
          )}
          {accessID == "TR059" ? (
            <Tooltip arrow title="Report">
              <AssessmentIcon
                sx={{ marginTop: "10px" }}
                color="primary"
                onClick={() => {
                  navigate("/Apps/TR100/Editreport/EditReport/1/A");
                }}
              />
            </Tooltip>
          ) : (
            false
          )}

          <GridToolbarExport
            printOptions={{ disableToolbarButton: true }}
            csvOptions={{
              fileName: `${screenName}`,
            }}
          />

          <Tooltip arrow title="Logout">
            <IconButton onClick={() => fnLogOut("Logout")} color="error">
              <LogoutOutlinedIcon />
            </IconButton>
          </Tooltip> */}
        </Box>
      </GridToolbarContainer>
    );
  }
  // const initialFilterValues = {
  //   fromDate: "",
  //   toDate: "",
  //   self: false,
  //   manager: false,
  //   sprint: false,
  //   assigned: false,
  //   scheduled: false,
  //   inprogress: false,
  //   completed: false,
  //   approved: false,
  //   subordinates: false,
  //   project: [],
  // };
  const oneMonthBefore = new Date();
  oneMonthBefore.setMonth(today.getMonth() - 1);

  const format = (d) => d.toISOString().split("T")[0];

  const defaultFromDate = format(oneMonthBefore);
  const defaultToDate = format(today);


  const initialFilterValues = {
    project: [],
    Employee: null,
    overhead: [],
    Status: "AL",
    fromDate: defaultFromDate || "",
    toDate: defaultToDate || "",
    self: true,
    Type: "ByProject"

  };

  // const savedFilters = sessionStorage.getItem("TR264_Filters");
  const savedFilters = sessionStorage.getItem("TR293_Filters");
  const parsedFilters = savedFilters ? JSON.parse(savedFilters) : initialFilterValues;
  const handlePagechange = (pageno) => {
    setPage(pageno);
    sessionStorage.setItem("currentPage", pageno);
  };

  return (
    <React.Fragment>
      <Box m="5px">
        <Box
          m="5px 0 0 0"
          padding={2}
          height={dataGridHeight}
          sx={{
            display: "flex",
            direction: "row",
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[800],
              // borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[800],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .odd-row": {
              backgroundColor: "",
              color: "", // Color for odd rows
            },
            "& .even-row": {
              backgroundColor: "#d0edec",
              color: "", // Color for even rows
            },
          }}
        >

          <DataGrid
            sx={{
              "& .MuiDataGrid-footerContainer": {
                height: dataGridHeaderFooterHeight,
                minHeight: dataGridHeaderFooterHeight,
              },
            }}
            key={accessID}
            rows={listViewData}
            columns={columnShow}
            loading={loading}
            disableSelectionOnClick
            // getRowId={(row) => row.RecordID}
            getRowId={(row, index) =>
              row.SLNO > 0
                ? `${row.RecordID}-${row.SLNO}`
                : `${row.RecordID}-${index}`
            }

            rowHeight={dataGridRowHeight}
            headerHeight={dataGridHeaderFooterHeight}
            pageSize={pageSize}
            page={page}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 15, 20]}
            onPageChange={(pageno) => handlePagechange(pageno)}
            components={{
              // Toolbar: CustomToolbar,
              Toolbar: () => CustomToolbar(listViewData),

            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "odd-row"
                : "even-row"
            }
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}

          />
          {/* {showMore && accessID === "TR264" && ( */}
          {showMore && accessID === "TR293" && (
            <Box
              sx={{
                width: 320,
                p: 2,
                borderRadius: 1,
                backgroundColor: "#fff",
              }}
            >
              <Formik
                initialValues={parsedFilters}
                enableReinitialize
                validate={(values) => {
                  // const hasAtLeastOneValue =
                  //   values.project.length > 0 ||
                  //   values.Employee ||
                  //   values.overhead.length > 0 ||
                  //   values.Status ||
                  //   values.fromDate ||
                  //   values.toDate ||
                  //   values.self;

                  // const errors = {};
                  // if (!hasAtLeastOneValue) {
                  //   toast.error("Please fill at least one field or check at least one option.");
                  //   errors.custom = "Please fill at least one field or check at least one option.";
                  // }
                  // return errors;
                }}

                onSubmit={(values, { setSubmitting }) => {
                  // Continue with normal logic if valid
                  const conditions = [];
                  const selectedStatusArr = values.Status.split(",");

                  // const fromDate = formattedDate2(values.fromDate);
                  // const toDate = formattedDate2(values.toDate);
                  // sessionStorage.setItem("TR264_Filters", JSON.stringify(values));
                  sessionStorage.setItem("TR293_Filters", JSON.stringify(values));
                  if (values.fromDate && values.toDate) {
                    conditions.push(`FilterDate BETWEEN '${values.fromDate}' AND '${values.toDate}'`);
                  }
                  if (values.Status) {
                    conditions.push(`AppStatus='${values.Status}'`);
                  }
                  const statusCodes = selectedStatusArr
                    .map((s) => statusCodeMap[s])
                    .join(",");
                  // if (values.Status) {
                  //   // conditions.push(`AppStatus='${values.Status}'`);
                  //   conditions.push(`AppStatus IN (${statusCodes})`);
                  // }
                  // if (values.Employee?.length > 0) {
                  //   const empIds = values.Employee.map((e) => `'${e.RecordID || e}'`).join(",");
                  //   conditions.push(`EmployeesID IN (${empIds})`);
                  // } 
                  if (values.Employee?.RecordID) {
                    conditions.push(`EmployeeID IN (${values.Employee?.RecordID})`);
                  }

                  else if (values.self) {
                    conditions.push(`EmployeeID='${EMPID}'`);
                  }
                  if (values.project?.length > 0) {
                    const projIds = values.project.map((p) => `'${p.RecordID}'`).join(",");
                    conditions.push(`ProjectID IN (${projIds})`);
                  }
                  // if (values.overhead?.RecordID) {
                  //   conditions.push(`OverheadID='${values.overhead.RecordID}'`);
                  // }
                  if (values.overhead?.length > 0) {
                    const OHIds = values.overhead.map((p) => `'${p.RecordID}'`).join(",");
                    // conditions.push(`OverheadID IN (${OHIds})`);
                    conditions.push(`HeaderOverheadID IN (${OHIds})`);
                  }

                  conditions.push(`CompanyID='${companyID}'`);

                  const whereClause = conditions.join(" AND ");
                  dispatch(fetchListview("TR293", screenName, whereClause, "", companyID));
                  setTimeout(() => setSubmitting(false), 100);
                }}
              >
                {({ values, handleChange, handleBlur, handleSubmit, resetForm, setFieldValue, isSubmitting }) => (
                  <form onSubmit={handleSubmit}
                  >
                    <Box sx={{ height: 600, overflowY: "auto" }}>
                      <IconButton
                        size="small"
                        onClick={() => setShowMore(false)}
                        sx={{ position: "absolute", top: 5, right: 4 }}
                      >
                        <Tooltip title="Close">
                          <CancelIcon color="error" />
                        </Tooltip>
                      </IconButton>
                      <MultiFormikOptimizedAutocomplete
                        sx={{ width: "100%", mt: 2 }}
                        name="project"
                        label="Project"
                        id="project"
                        value={values.project}
                        onChange={(e, newValue) => setFieldValue("project", newValue)}
                        url={`${listViewurl}?data=${encodeURIComponent(
                          JSON.stringify({
                            Query: {
                              AccessID: "2114",
                              ScreenName: "Project",
                              Filter: `parentID=${companyID} AND EmployeeID=${EMPID}`,
                              Any: "",
                            },
                          })
                        )}`}
                      />
                      <MultiFormikOptimizedAutocomplete
                        sx={{ width: "100%", mt: 2 }}
                        name="overhead"
                        label="Overhead"
                        id="overhead"
                        value={values.overhead}
                        onChange={(e, newValue) => setFieldValue("overhead", newValue)}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"OverHead","Filter":"companyID='${companyID}' AND ChildYorN = 'Y'","Any":""}}`}

                      />
                      <Employeeautocomplete
                        sx={{ width: "100%", mt: 2 }}
                        name="Employee"
                        label="Employee"
                        id="Employee"
                        value={values.Employee}
                        onChange={(newValue) => {
                          setFieldValue("Employee", newValue)
                          setFieldValue("self", false)
                        }}
                        url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
                      />
                      <TextField
                        select
                        fullWidth
                        focused
                        label="Type"
                        id="Type"
                        name="Type"
                        value={values.Type}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="standard"
                        sx={{ width: "100%", mt: 2 }}
                      >
                        <MenuItem value="ByProject">By Project</MenuItem>
                        <MenuItem value="ByOverhead">By Overhead</MenuItem>
                      </TextField>

                      <TextField
                        fullWidth
                        label="From Date"
                        type="date"
                        name="fromDate"
                        value={values.fromDate}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: "100%", mt: 2 }}
                        focused
                      />
                      <TextField
                        fullWidth
                        label="To Date"
                        type="date"
                        name="toDate"
                        value={values.toDate}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: "100%", mt: 2 }}
                        focused
                      />
                      <TextField
                        select
                        multiple
                        fullWidth
                        focused
                        label="Status"
                        id="Status"
                        name="Status"
                        value={values.Status}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="standard"
                        sx={{ width: "100%", mt: 2 }}
                      >
                        <MenuItem value="AL">Applied</MenuItem>
                        <MenuItem value="AP">Approved</MenuItem>
                        <MenuItem value="QR">Query</MenuItem>
                      </TextField>
                      {/* <FormControl
                        variant="standard"
                        // sx={{ }}
                        sx={{ marginTop: "5px", minWidth: 160 }}
                        fullWidth
                        focused
                      >
                        <InputLabel id="Status-label">Status</InputLabel>

                        <Select
                          labelId="Status-label"
                          id="Status"
                          name="Status"
                          multiple
                          value={
                            Array.isArray(values.Status)
                              ? values.Status
                              : typeof values.Status === "string" && values.Status.length > 0
                                ? values.Status.split(",")
                                : []
                          }
                          onChange={(e) => {
                            handleChange({
                              target: {
                                name: "Status",
                                value: e.target.value.join(",")
                              }
                            });
                          }}
                          onBlur={handleBlur}
                          renderValue={(selected) => selected.join(", ")}
                        >
                          <MenuItem value="Applied">Applied</MenuItem>
                          <MenuItem value="Approved">Approved</MenuItem>
                          <MenuItem value="Query">Query</MenuItem>
                        </Select>
                      </FormControl> */}
                      <Box display="flex" alignItems="center">
                        <Checkbox
                          checked={values.self}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setFieldValue("self", checked);
                            setFieldValue("Employee", null);
                            // sessionStorage.setItem("TR264_useCurrentEmp", checked ? "Y" : "N");
                            sessionStorage.setItem("TR293_useCurrentEmp", checked ? "Y" : "N");
                          }}
                          color="primary"
                          id="self-checkbox"
                        />
                        <label htmlFor="self-checkbox" style={{ marginLeft: 8, cursor: "default" }}>
                          Self
                        </label>
                      </Box>
                      <Stack direction="row" alignItems="center" justifyContent="end" spacing={1} marginTop={3}>
                        <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                          Apply
                        </Button>
                        {values.Type === "ByProject" ? (
                          <PDFDownloadLink
                            document={
                              <OnsitesummaryPDF
                                data={listViewData}
                                Project={values?.project}
                                Overhead={values?.overhead}
                                filters={{
                                  Imageurl: baseurl1,
                                  HeaderImg: HeaderImg,
                                  FooterImg: FooterImg,
                                }}
                              />
                            }
                            fileName={`Summary_${values?.Employee?.Name || "Employee"}.pdf`}
                            style={{ color: "#d32f2f", cursor: "pointer" }}
                          >
                            {({ loading }) =>
                              loading ? (
                                <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                              ) : (
                                <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                              )
                            }
                          </PDFDownloadLink>
                        ) : (
                          <PDFDownloadLink
                            document={
                              <OHsummaryPDF
                                data={listViewData}
                                Project={values?.project}
                                Overhead={values?.overhead}
                                filters={{
                                  Imageurl: baseurl1,
                                  HeaderImg: HeaderImg,
                                  FooterImg: FooterImg,
                                }}


                              />
                            }
                            fileName={`Summary_${values?.Employee?.Name || "Employee"}.pdf`}
                            style={{ color: "#d32f2f", cursor: "pointer" }}
                          >
                            {({ loading }) =>
                              loading ? (
                                <PictureAsPdfIcon sx={{ fontSize: 24, opacity: 0.5 }} />
                              ) : (
                                <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                              )
                            }
                          </PDFDownloadLink>
                        )}
                        {/* <Button
                          type="reset"
                          variant="contained"
                          color="error"
                          size="small"
                        >
                          RESET
                        </Button> */}
                        <Button
                          type="button"
                          variant="contained"
                          color="error"
                          onClick={() => {
                            // sessionStorage.removeItem("TR264_Filters");
                            // sessionStorage.removeItem("TR264_useCurrentEmp");
                            sessionStorage.removeItem("TR293_Filters");
                            sessionStorage.removeItem("TR293_useCurrentEmp");

                            resetForm({
                              values: {
                                project: [],
                                Employee: null,
                                overhead: [],
                                Status: "",
                                fromDate: defaultFromDate,
                                toDate: defaultToDate,
                                self: true,
                                Type: "ByProject",
                              },
                            });
                          }}
                        >
                          RESET
                        </Button>
                      </Stack>
                    </Box>
                  </form>
                )}
              </Formik>

            </Box>
          )}
          {showMore && accessID === "TR331" && (() => {

            // Restore session filters
            const savedFilters =
              JSON.parse(sessionStorage.getItem("TR331_Filters")) || {};

            const initialFormValues = {
              fromDate: savedFilters.fromDate || defaultFromDate,
              toDate: savedFilters.toDate || defaultToDate,
              project: savedFilters.project || [],
              Employee: savedFilters.Employee || [],
              attmonth: savedFilters.attmonth || currentMonthNumber,
              attyear: savedFilters.attyear || currentYear,
            };

            return (
              <Box
                sx={{
                  width: 320,
                  p: 2,
                  borderRadius: 1,
                  backgroundColor: "#fff",
                  position: "relative"
                }}
              >
                <Formik
                  initialValues={initialFormValues}
                  enableReinitialize
                  onSubmit={(values, { setSubmitting }) => {

                    // Save filters to session
                    sessionStorage.setItem(
                      "TR331_Filters",
                      JSON.stringify(values)
                    );

                    const conditions = [];
                    // const fromDate = formattedDate2(values.fromDate);
                    // const toDate = formattedDate2(values.toDate);

                    if (values.fromDate && values.toDate) {
                      conditions.push(
                        `FilterDate BETWEEN '${values.fromDate}' AND '${values.toDate}'`
                      );
                    }

                    if (values.attmonth) {
                      conditions.push(
                        `BillableMonth='${values.attmonth}'`
                      );
                    }

                    if (values.attyear) {
                      conditions.push(
                        `BillableYear='${values.attyear}'`
                      );
                    }

                    if (values.Employee?.length > 0) {
                      const EmpIds = values.Employee
                        .map((e) => `'${e.RecordID}'`)
                        .join(",");
                      conditions.push(`EmployeeID IN (${EmpIds})`);
                    }

                    if (values.project?.length > 0) {
                      const projIds = values.project
                        .map((p) => `'${p.RecordID}'`)
                        .join(",");
                      conditions.push(`ProjectID IN (${projIds})`);
                    }

                    conditions.push(`CompanyID='${companyID}'`);

                    const whereClause = conditions.join(" AND ");

                    dispatch(
                      fetchListview(
                        "TR331",
                        screenName,
                        whereClause,
                        "",
                        companyID
                      )
                    );

                    setTimeout(() => setSubmitting(false), 100);
                  }}
                >
                  {({
                    values,
                    handleChange,
                    handleSubmit,
                    resetForm,
                    setFieldValue,
                    isSubmitting
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Box sx={{ height: 600, overflowY: "auto" }}>

                        {/* Close Button */}
                        <IconButton
                          size="small"
                          onClick={() => setShowMore(false)}
                          sx={{ position: "absolute", top: 5, right: 4 }}
                        >
                          <Tooltip title="Close">
                            <CancelIcon color="error" />
                          </Tooltip>
                        </IconButton>

                        {/* From Date */}
                        <TextField
                          fullWidth
                          label="From Date"
                          type="date"
                          name="fromDate"
                          value={values.fromDate}
                          onChange={handleChange}
                          InputLabelProps={{ shrink: true }}
                          sx={{ mt: 2 }}
                          focused
                        />

                        {/* To Date */}
                        <TextField
                          fullWidth
                          label="To Date"
                          type="date"
                          name="toDate"
                          value={values.toDate}
                          onChange={handleChange}
                          InputLabelProps={{ shrink: true }}
                          sx={{ mt: 2 }}
                          focused
                        />

                        {/* Project */}
                        <MultiFormikOptimizedAutocomplete
                          sx={{ mt: 2 }}
                          name="project"
                          label={is003Subscription ? "Standard/Activities" : "Project"}
                          value={values.project}
                          onChange={(e, newValue) =>
                            setFieldValue("project", newValue)
                          }
                          url={`${listViewurl}?data=${encodeURIComponent(
                            JSON.stringify({
                              Query: {
                                AccessID: "2114",
                                ScreenName: "Project",
                                Filter: `parentID=${companyID} AND EmployeeID=${EMPID}`,
                                Any: "",
                              },
                            })
                          )}`}
                        />

                        {/* Employee */}
                        <MultiFormikOptimizedAutocomplete
                          sx={{ mt: 2 }}
                          name="Employee"
                          label={is003Subscription ? "Student" : "Personnel"}
                          value={values.Employee}
                          onChange={(e, newValue) =>
                            setFieldValue("Employee", newValue)
                          }
                          url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
                        />

                        {/*  Month */}
                        {/* <TextField
                          sx={{ mt: 2 }}
                          variant="standard"
                          label="Month"
                          name="attmonth"
                          value={values.attmonth}
                          onChange={handleChange}
                          select
                          fullWidth
                          focused
                        >
                          {[
                            "January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                          ].map((month, index) => (
                            <MenuItem key={index + 1} value={index + 1}>
                              {month}
                            </MenuItem>
                          ))}
                        </TextField> */}
                        <TextField
                          sx={{ mt: 2 }}
                          variant="standard"
                          label="Month"
                          name="attmonth"
                          value={values.attmonth || ""}
                          onChange={handleChange}
                          select
                          fullWidth
                          focused
                          InputProps={{
                            endAdornment: values.attmonth && (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  sx={{ marginRight: 2 }}
                                  onClick={() => setFieldValue("attmonth", "")}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        >
                          {[
                            "January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                          ].map((month, index) => (
                            <MenuItem key={index + 1} value={index + 1}>
                              {month}
                            </MenuItem>
                          ))}
                        </TextField>

                        {/* Year */}
                        {/* <TextField
                          sx={{ mt: 2 }}
                          variant="standard"
                          label="Year"
                          name="attyear"
                          value={values.attyear}
                          onChange={handleChange}
                          select
                          fullWidth
                          focused
                        >
                          <MenuItem value="2026">2026</MenuItem>
                          <MenuItem value="2025">2025</MenuItem>
                        </TextField> */}
                        <TextField
                          sx={{ mt: 2 }}
                          variant="standard"
                          label="Year"
                          name="attyear"
                          value={values.attyear || ""}
                          onChange={handleChange}
                          select
                          fullWidth
                          focused
                          InputProps={{
                            endAdornment: values.attyear && (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  sx={{ marginRight: 2 }}
                                  onClick={() => setFieldValue("attyear", "")}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        >
                          <MenuItem value="2026">2026</MenuItem>
                          <MenuItem value="2025">2025</MenuItem>
                        </TextField>

                        {/* Buttons */}
                        <Stack
                          direction="row"
                          justifyContent="end"
                          spacing={1}
                          mt={3}
                        >
                          <Button
                            type="submit"
                            variant="contained"
                            disabled={isSubmitting}
                          >
                            Apply
                          </Button>

                          <PDFDownloadLink
                            document={
                              <InvpaymentPDF
                                data={listViewData}
                                Project={values?.project}
                                filters={{
                                  Imageurl: baseurl1,
                                  HeaderImg: HeaderImg,
                                  FooterImg: FooterImg,
                                  fromDate: values.fromDate,
                                  toDate: values.toDate
                                }}
                              />
                            }
                            fileName="Invoice_pdf"
                            style={{ color: "#d32f2f" }}
                          >
                            {({ loading }) =>
                              loading ? (
                                <PictureAsPdfIcon sx={{ opacity: 0.5 }} />
                              ) : (
                                <PictureAsPdfIcon />
                              )
                            }
                          </PDFDownloadLink>

                          <Button
                            type="button"
                            variant="contained"
                            color="error"
                            onClick={() => {
                              sessionStorage.removeItem("TR331_Filters");

                              resetForm({
                                values: {
                                  project: [],
                                  Employee: [],
                                  fromDate: defaultFromDate,
                                  toDate: defaultToDate,
                                  attmonth: currentMonthNumber,
                                  attyear: currentYear,
                                },
                              });
                            }}
                          >
                            RESET
                          </Button>
                        </Stack>

                      </Box>
                    </form>
                  )}
                </Formik>
              </Box>
            );

          })()}
          {showMore && accessID === "TR366" && (() => {

            // Restore session filters
            const savedFilters =
              JSON.parse(sessionStorage.getItem("TR366_Filters")) || {};

            const initialFormValues = {
              fromDate: savedFilters.fromDate || defaultFromDate,
              toDate: savedFilters.toDate || defaultToDate,
              project: savedFilters.project || [],
              Employee: savedFilters.Employee || [],
              attmonth: savedFilters.attmonth || currentMonthNumber,
              attyear: savedFilters.attyear || currentYear,
            };

            return (
              <Box
                sx={{
                  width: 320,
                  p: 2,
                  borderRadius: 1,
                  backgroundColor: "#fff",
                  position: "relative"
                }}
              >
                <Formik
                  initialValues={initialFormValues}
                  enableReinitialize
                  onSubmit={(values, { setSubmitting }) => {

                    // Save filters to session
                    sessionStorage.setItem(
                      "TR366_Filters",
                      JSON.stringify(values)
                    );

                    const conditions = [];
                    // const fromDate = formattedDate2(values.fromDate);
                    // const toDate = formattedDate2(values.toDate);

                    if (values.fromDate && values.toDate) {
                      conditions.push(
                        `FilterDate BETWEEN '${values.fromDate}' AND '${values.toDate}'`
                      );
                    }

                    if (values.attmonth) {
                      conditions.push(
                        `BillableMonth='${values.attmonth}'`
                      );
                    }

                    if (values.attyear) {
                      conditions.push(
                        `BillableYear='${values.attyear}'`
                      );
                    }

                    if (values.Employee?.length > 0) {
                      const EmpIds = values.Employee
                        .map((e) => `'${e.RecordID}'`)
                        .join(",");
                      conditions.push(`EmployeeID IN (${EmpIds})`);
                    }

                    if (values.project?.length > 0) {
                      const projIds = values.project
                        .map((p) => `'${p.RecordID}'`)
                        .join(",");
                      conditions.push(`ProjectID IN (${projIds})`);
                    }

                    // conditions.push(`CompanyID='${companyID}' AND Source ='Dailytask'`);
                    conditions.push(`CompanyID='${companyID}'`);

                    const whereClause = conditions.join(" AND ");

                    dispatch(
                      fetchListview(
                        "TR366",
                        screenName,
                        whereClause,
                        "",
                        companyID
                      )
                    );

                    setTimeout(() => setSubmitting(false), 100);
                  }}
                >
                  {({
                    values,
                    handleChange,
                    handleSubmit,
                    resetForm,
                    setFieldValue,
                    isSubmitting
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Box sx={{ height: 600, overflowY: "auto" }}>

                        {/* Close Button */}
                        <IconButton
                          size="small"
                          onClick={() => setShowMore(false)}
                          sx={{ position: "absolute", top: 5, right: 4 }}
                        >
                          <Tooltip title="Close">
                            <CancelIcon color="error" />
                          </Tooltip>
                        </IconButton>

                        {/* From Date */}
                        <TextField
                          fullWidth
                          label="From Date"
                          type="date"
                          name="fromDate"
                          value={values.fromDate}
                          onChange={handleChange}
                          InputLabelProps={{ shrink: true }}
                          sx={{ mt: 2 }}
                          focused
                        />

                        {/* To Date */}
                        <TextField
                          fullWidth
                          label="To Date"
                          type="date"
                          name="toDate"
                          value={values.toDate}
                          onChange={handleChange}
                          InputLabelProps={{ shrink: true }}
                          sx={{ mt: 2 }}
                          focused
                        />

                        {/* Project */}
                        <MultiFormikOptimizedAutocomplete
                          sx={{ mt: 2 }}
                          name="project"
                          label="Project"
                          value={values.project}
                          onChange={(e, newValue) =>
                            setFieldValue("project", newValue)
                          }
                          url={`${listViewurl}?data=${encodeURIComponent(
                            JSON.stringify({
                              Query: {
                                AccessID: "2114",
                                ScreenName: "Project",
                                Filter: `parentID=${companyID} AND EmployeeID=${EMPID}`,
                                Any: "",
                              },
                            })
                          )}`}
                        />

                        {/* Employee */}
                        <MultiFormikOptimizedAutocomplete
                          sx={{ mt: 2 }}
                          name="Employee"
                          label="Employee"
                          value={values.Employee}
                          onChange={(e, newValue) =>
                            setFieldValue("Employee", newValue)
                          }
                          url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
                        />

                        {/*  Month */}
                        {/* <TextField
                          sx={{ mt: 2 }}
                          variant="standard"
                          label="Month"
                          name="attmonth"
                          value={values.attmonth}
                          onChange={handleChange}
                          select
                          fullWidth
                          focused
                        >
                          {[
                            "January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                          ].map((month, index) => (
                            <MenuItem key={index + 1} value={index + 1}>
                              {month}
                            </MenuItem>
                          ))}
                        </TextField> */}
                        <TextField
                          sx={{ mt: 2 }}
                          variant="standard"
                          label="Month"
                          name="attmonth"
                          value={values.attmonth || ""}
                          onChange={handleChange}
                          select
                          fullWidth
                          focused
                          InputProps={{
                            endAdornment: values.attmonth && (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  sx={{ marginRight: 2 }}
                                  onClick={() => setFieldValue("attmonth", "")}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        >
                          {[
                            "January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                          ].map((month, index) => (
                            <MenuItem key={index + 1} value={index + 1}>
                              {month}
                            </MenuItem>
                          ))}
                        </TextField>

                        {/* Year */}
                        {/* <TextField
                          sx={{ mt: 2 }}
                          variant="standard"
                          label="Year"
                          name="attyear"
                          value={values.attyear}
                          onChange={handleChange}
                          select
                          fullWidth
                          focused
                        >
                          <MenuItem value="2026">2026</MenuItem>
                          <MenuItem value="2025">2025</MenuItem>
                        </TextField> */}
                        <TextField
                          sx={{ mt: 2 }}
                          variant="standard"
                          label="Year"
                          name="attyear"
                          value={values.attyear || ""}
                          onChange={handleChange}
                          select
                          fullWidth
                          focused
                          InputProps={{
                            endAdornment: values.attyear && (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  sx={{ marginRight: 2 }}
                                  onClick={() => setFieldValue("attyear", "")}
                                >
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        >
                          <MenuItem value="2026">2026</MenuItem>
                          <MenuItem value="2025">2025</MenuItem>
                        </TextField>

                        {/* Buttons */}
                        <Stack
                          direction="row"
                          justifyContent="end"
                          spacing={1}
                          mt={3}
                        >
                          <Button
                            type="submit"
                            variant="contained"
                            disabled={isSubmitting}
                          >
                            Apply
                          </Button>

                          <PDFDownloadLink
                            document={
                              <InvpaymentPDF
                                data={listViewData}
                                Project={values?.project}
                                filters={{
                                  Imageurl: baseurl1,
                                  HeaderImg: HeaderImg,
                                  FooterImg: FooterImg,
                                  fromDate: values.fromDate,
                                  toDate: values.toDate
                                }}
                              />
                            }
                            fileName="Invoice_pdf"
                            style={{ color: "#d32f2f" }}
                          >
                            {({ loading }) =>
                              loading ? (
                                <PictureAsPdfIcon sx={{ opacity: 0.5 }} />
                              ) : (
                                <PictureAsPdfIcon />
                              )
                            }
                          </PDFDownloadLink>

                          <Button
                            type="button"
                            variant="contained"
                            color="error"
                            onClick={() => {
                              sessionStorage.removeItem("TR366_Filters");

                              resetForm({
                                values: {
                                  project: [],
                                  Employee: [],
                                  fromDate: defaultFromDate,
                                  toDate: defaultToDate,
                                  attmonth: currentMonthNumber,
                                  attyear: currentYear,
                                },
                              });
                            }}
                          >
                            RESET
                          </Button>
                        </Stack>

                      </Box>
                    </form>
                  )}
                </Formik>
              </Box>
            );

          })()}
          {showMore && accessID === "TR132" && !is003Subscription && (
            <Box
              sx={{
                width: 300,
                p: 2,
                borderRadius: 1,
                backgroundColor: "#fff",
              }}
            >
              <Formik
                initialValues={{
                  fromdate:
                    sessionStorage.getItem("FromDate") ||
                    new Date().toISOString().split("T")[0], // current date
                  date:
                    sessionStorage.getItem("ToDate") ||
                    new Date().toISOString().split("T")[0], // current date
                  project: JSON.parse(sessionStorage.getItem("TR132_project") || "[]"),
                  // ✅ Default: Self checked, others false (if not saved)
                  TaskType: JSON.parse(sessionStorage.getItem("TR132_TaskType") || "[]"),
                  self:
                    sessionStorage.getItem("TR132_self") === "Y" ||
                    (!sessionStorage.getItem("TR132_self") &&
                      !sessionStorage.getItem("TR132_manager") &&
                      !sessionStorage.getItem("TR132_sprint")),
                  manager: sessionStorage.getItem("TR132_manager") === "Y",
                  sprint: sessionStorage.getItem("TR132_sprint") === "Y",

                  assigned: sessionStorage.getItem("TR132_assigned") === "Y",
                  scheduled: sessionStorage.getItem("TR132_scheduled") === "Y",
                  inprogress: sessionStorage.getItem("TR132_inprogress") === "Y",
                  completed: sessionStorage.getItem("TR132_completed") === "Y",
                  approved: sessionStorage.getItem("TR132_approved") === "Y",
                  query: sessionStorage.getItem("TR132_query") === "Y",
                }}
                enableReinitialize
                validate={(values) => {
                  const hasAtLeastOneValue =
                    values.fromdate ||
                    values.date ||
                    values.project?.length > 0 ||
                    values.self ||
                    values.manager ||
                    values.sprint ||
                    values.assigned ||
                    values.scheduled ||
                    values.inprogress ||
                    values.completed ||
                    values.approved ||
                    values.query;

                  // const errors = {};
                  // if (!hasAtLeastOneValue) {
                  //   toast.error("Please fill at least one field.");
                  //   errors.custom = "Please fill at least one field.";
                  // }
                  // return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                  const conditions = [];
                  const empId = sessionStorage.getItem("EmployeeID") || EMPID;
                  const fromDate = values.fromdate;
                  const toDate = values.date;

                  // ✅ Save all fields in session
                  sessionStorage.setItem("FromDate", fromDate);
                  sessionStorage.setItem("ToDate", toDate);
                  sessionStorage.setItem("EmployeeID", empId);
                  sessionStorage.setItem(
                    "TR132_project",
                    JSON.stringify(values.project || [])
                  );
                  sessionStorage.setItem(
                    "TR132_TaskType",
                    JSON.stringify(values.TaskType || [])
                  );
                  sessionStorage.setItem("TR132_self", values.self ? "Y" : "N");
                  sessionStorage.setItem("TR132_manager", values.manager ? "Y" : "N");
                  sessionStorage.setItem("TR132_sprint", values.sprint ? "Y" : "N");

                  ["assigned", "scheduled", "inprogress", "completed", "approved", "query"].forEach((key) => {
                    sessionStorage.setItem(`TR132_${key}`, values[key] ? "Y" : "N");
                  });

                  // Build the WHERE clause
                  conditions.push(`EmployeesID='${empId}'`);
                  if (fromDate && toDate) {
                    conditions.push(`DAILYTASKDATE BETWEEN '${fromDate}' AND '${toDate}'`);
                  }
                  if (values.TaskType && values.TaskType.length > 0) {
                    const TaskCodes = values.TaskType.map(t => t).join("','");
                    conditions.push(`TaskType IN ('${TaskCodes}')`);
                  }

                  const statusFilters = [];
                  if (values.assigned) statusFilters.push("'AS'");
                  if (values.scheduled) statusFilters.push("'SH'");
                  if (values.inprogress) statusFilters.push("'I'");
                  if (values.completed) statusFilters.push("'C'");
                  if (values.approved) statusFilters.push("'AP'");
                  if (values.query) statusFilters.push("'RJ'");

                  if (statusFilters.length > 0)
                    conditions.push(`FilterStatus IN (${statusFilters.join(",")})`);

                  const sourceFilters = [];
                  if (values.self) sourceFilters.push("'Self'");
                  if (values.manager) sourceFilters.push("'Manager'");
                  if (values.sprint) sourceFilters.push("'Sprint'");
                  if (sourceFilters.length > 0)
                    conditions.push(`TaskSource IN (${sourceFilters.join(", ")})`);

                  if (values.project && values.project.length > 0) {
                    const projectIDs = values.project
                      .map((p) => `'${p.RecordID}'`)
                      .join(",");
                    conditions.push(`ProjectID IN (${projectIDs})`);
                  }

                  conditions.push(`CompanyID='${companyID}'`);
                  const whereClause = conditions.join(" AND ");

                  dispatch(fetchListview(accessID, screenName, whereClause, "", companyID));
                  setTimeout(() => setSubmitting(false), 100);
                }}
              // onReset={(values, { setFieldValue }) => handleResetFilters(setFieldValue)}
              >

                {({
                  values,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  handleBlur,
                  handleChange
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sx={{ height: 600, overflowY: "auto" }}>
                      <IconButton
                        size="small"
                        onClick={() => setShowMore(false)}
                        sx={{ position: "absolute", top: 5, right: 4 }}
                      >
                        <Tooltip title="Close">
                          <CancelIcon color="error" />
                        </Tooltip>
                      </IconButton>
                      <MultiFormikOptimizedAutocomplete
                        sx={{ width: 250, mt: 1 }}
                        name="project"
                        label="Project"
                        id="project"
                        value={values.project}
                        onChange={(e, newValue) => {
                          setFieldValue("project", newValue)
                          sessionStorage.setItem("TR132_project", JSON.stringify(newValue || []));
                        }}
                        url={`${listViewurl}?data=${encodeURIComponent(
                          JSON.stringify({
                            Query: {
                              AccessID: "2114",
                              ScreenName: "Project",
                              Filter: `parentID=${companyID} AND EmployeeID=${EMPID}`,
                              Any: "",
                            },
                          })
                        )}`}
                      />

                      <TextField
                        name="fromdate"
                        type="date"
                        id="fromdate"
                        label="From Date"
                        variant="standard"
                        value={values.fromdate || ""}
                        onChange={(e) => {
                          const newDate = e.target.value;
                          setFieldValue("fromdate", newDate);
                          dispatch(setFromDate(newDate));
                          sessionStorage.setItem("FromDate", newDate);
                        }}
                        focused
                        InputLabelProps={{ shrink: true }}
                        // inputProps={{ max: new Date().toISOString().split("T")[0] }}
                        sx={{ width: 250, mt: 1 }}
                      />

                      <TextField
                        name="date"
                        type="date"
                        id="date"
                        label="To Date"
                        variant="standard"
                        value={values.date || ""}
                        onChange={(e) => {
                          const newDate = e.target.value;
                          setFieldValue("date", newDate);
                          dispatch(setToDate(newDate));
                          sessionStorage.setItem("ToDate", newDate);
                        }}
                        focused
                        InputLabelProps={{ shrink: true }}
                        // inputProps={{ max: new Date().toISOString().split("T")[0] }}
                        sx={{ width: 250, mt: 1 }}
                      />

                      {isManager == 1 && accessID === "TR132" && (
                        <Employeeautocomplete
                          sx={{ width: 250, mt: 1 }}
                          name="empName"
                          label="Employee"
                          id="empName"
                          value={selectedEmp}
                          onChange={(newValue) => {
                            if (newValue) {
                              setSelectedEmp(newValue);
                              const EmpId = newValue.RecordID;
                              dispatch(setEmployeeID(EmpId));
                              sessionStorage.setItem("EmployeeID", EmpId);
                              sessionStorage.setItem("EmployeeName", newValue.Name);
                            } else {
                              setSelectedEmp(null);
                              sessionStorage.removeItem("EmployeeID");
                              sessionStorage.removeItem("EmployeeName");
                              dispatch(setEmployeeID(""));
                            }
                          }}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
                        />
                      )}
                      <FormControl
                        variant="standard"
                        sx={{ width: 250, mt: 1 }}
                        focused
                      >
                        <InputLabel id="TaskType-label">Task Type</InputLabel>

                        <Select
                          labelId="TaskType-label"
                          id="TaskType"
                          name="TaskType"
                          multiple
                          value={Array.isArray(values.TaskType) ? values.TaskType : []}
                          onChange={(e) => {
                            const selectedValues = e.target.value;
                            handleChange({
                              target: {
                                name: "TaskType",
                                value: e.target.value       // <-- store array directly
                              }
                            });
                            sessionStorage.setItem("TR132_TaskType", JSON.stringify(selectedValues));

                          }}
                          onBlur={handleBlur}
                          renderValue={(selected) => selected.join(", ")}
                        >
                          <MenuItem value="Normal">Normal</MenuItem>
                          <MenuItem value="Learning&development">Learning & development</MenuItem>
                          <MenuItem value="Research&development">Research & development</MenuItem>
                          <MenuItem value="Up-skill">Up-skill</MenuItem>
                          <MenuItem value="Bug">Bug</MenuItem>
                          <MenuItem value="Improvements">Improvements</MenuItem>
                          <MenuItem value="Minutes of Meeting">Minutes of Meeting</MenuItem>
                          <MenuItem value="Script">Script</MenuItem>
                          <MenuItem value="Documentation">Documentation</MenuItem>
                        </Select>
                      </FormControl>

                      {/* <TextField
                        sx={{ gridColumn: "span 2" }}
                        labelId="status2"
                        id="TaskType"
                        name="TaskType"
                        type="text"
                        focused
                        fullWidth
                        variant="standard"
                        label="Task Type"
                        value={values.TaskType}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.TaskType && !!errors.TaskType}
                        helperText={touched.TaskType && errors.TaskType}
                        select
                      >
                        <MenuItem value="Normal">Normal</MenuItem>
                        <MenuItem value="Learning&development">
                          Learning & development
                        </MenuItem>
                        <MenuItem value="Research&development">
                          Research & development
                        </MenuItem>
                        <MenuItem value="Up-skill">Up-skill</MenuItem>
                        <MenuItem value="Bug">Bug</MenuItem>
                        <MenuItem value="Improvements">Improvements</MenuItem>
                        <MenuItem value="Minutes of Meeting">
                          Minutes of Meeting
                        </MenuItem>
                        <MenuItem value="Script">Script</MenuItem>
                        <MenuItem value="Documentation">Documentation</MenuItem>
                      </TextField> */}

                      <Typography mt={2} fontWeight="bold" color="error">
                        Status
                      </Typography>
                      {[
                        "assigned",
                        "scheduled",
                        "inprogress",
                        "completed",
                        "approved",
                        "query",
                      ].map((field) => (
                        <FormControlLabel
                          key={field}
                          control={
                            <Checkbox
                              name={field}
                              checked={values[field] || false}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setFieldValue(field, checked);
                                sessionStorage.setItem(`TR132_${field}`, checked ? "Y" : "N");
                              }}
                            />
                          }
                          label={
                            field === "inprogress"
                              ? "In Progress"
                              : field.charAt(0).toUpperCase() + field.slice(1)
                          }
                        />
                      ))}

                      <Typography mt={2} fontWeight="bold" color="error">
                        Task Source
                      </Typography>
                      {["self", "manager", "sprint"].map((field) => (
                        <FormControlLabel
                          key={field}
                          control={
                            <Checkbox
                              name={field}
                              checked={values[field] || false}
                              onChange={(e) => setFieldValue(field, e.target.checked)}
                            />
                          }
                          label={field.charAt(0).toUpperCase() + field.slice(1)}
                        />
                      ))}

                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="end"
                        spacing={1}
                        mt={1}
                      >
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Apply
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => handleResetFilters(setFieldValue)}
                        >
                          Reset
                        </Button>
                      </Stack>
                    </Box>
                  </form>
                )}
              </Formik>
            </Box>
          )}

          {showMore && accessID === "TR354" && is003Subscription && (
            <Box
              sx={{
                width: 300,
                p: 2,
                borderRadius: 1,
                backgroundColor: "#fff",
              }}
            >
              <Formik
                initialValues={{
                  fromdate:
                    sessionStorage.getItem("FromDate") ||
                    new Date().toISOString().split("T")[0],

                  date:
                    sessionStorage.getItem("ToDate") ||
                    new Date().toISOString().split("T")[0],

                  project: JSON.parse(sessionStorage.getItem("TR354_project") || "[]"),

                  Milestone: JSON.parse(sessionStorage.getItem("TR354_Milestone") || "[]"),

                  TaskType: JSON.parse(sessionStorage.getItem("TR354_TaskType") || "[]"),

                  self:
                    sessionStorage.getItem("TR354_self") === "Y" ||
                    (!sessionStorage.getItem("TR354_self") &&
                      !sessionStorage.getItem("TR354_manager") &&
                      !sessionStorage.getItem("TR354_sprint")),

                  manager: sessionStorage.getItem("TR354_manager") === "Y",

                  sprint: sessionStorage.getItem("TR354_sprint") === "Y",

                  Teacher: sessionStorage.getItem("TR354_Teacher") === "Y",

                  assigned: sessionStorage.getItem("TR354_assigned") === "Y",
                  scheduled: sessionStorage.getItem("TR354_scheduled") === "Y",
                  inprogress: sessionStorage.getItem("TR354_inprogress") === "Y",
                  completed: sessionStorage.getItem("TR354_completed") === "Y",
                  approved: sessionStorage.getItem("TR354_approved") === "Y",
                  query: sessionStorage.getItem("TR354_query") === "Y",
                }}
                enableReinitialize
                validate={(values) => {
                  const hasAtLeastOneValue =
                    values.fromdate ||
                    values.date ||
                    values.project?.length > 0 ||
                    values.Milestone.length > 0 ||
                    values.Teacher ||
                    // values.self ||
                    // values.manager ||
                    // values.sprint ||
                    values.assigned ||
                    values.scheduled ||
                    values.inprogress ||
                    values.completed ||
                    values.approved ||
                    values.query;

                  // const errors = {};
                  // if (!hasAtLeastOneValue) {
                  //   toast.error("Please fill at least one field.");
                  //   errors.custom = "Please fill at least one field.";
                  // }
                  // return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                  const conditions = [];
                  const empId = sessionStorage.getItem("EmployeeID") || EMPID;
                  const fromDate = values.fromdate;
                  const toDate = values.date;

                  // ✅ Save all fields in session
                  sessionStorage.setItem("FromDate", fromDate);
                  sessionStorage.setItem("ToDate", toDate);
                  sessionStorage.setItem("EmployeeID", empId);
                  sessionStorage.setItem(
                    "TR354_project",
                    JSON.stringify(values.project || [])
                  );
                  sessionStorage.setItem(
                    "TR354_Milestone",
                    JSON.stringify(values.Milestone || [])
                  );
                  sessionStorage.setItem(
                    "TR354_TaskType",
                    JSON.stringify(values.TaskType || [])
                  );

                  sessionStorage.setItem("TR354_self", values.self ? "Y" : "N");
                  sessionStorage.setItem("TR354_manager", values.manager ? "Y" : "N");
                  sessionStorage.setItem("TR354_sprint", values.sprint ? "Y" : "N");
                  sessionStorage.setItem("TR354_Teacher", values.Teacher ? "Y" : "N");

                  ["assigned", "scheduled", "inprogress", "completed", "approved", "query"].forEach((key) => {
                    sessionStorage.setItem(`TR354_${key}`, values[key] ? "Y" : "N");
                  });

                  // Build the WHERE clause
                  conditions.push(`EmployeesID='${empId}'`);
                  if (fromDate && toDate) {
                    conditions.push(`DAILYTASKDATE BETWEEN '${fromDate}' AND '${toDate}'`);
                  }
                  // if (values.TaskType && values.TaskType.length > 0) {
                  //   const TaskCodes = values.TaskType.map(t => t).join("','");
                  //   conditions.push(`TaskType IN ('${TaskCodes}')`);
                  // }

                  const statusFilters = [];
                  if (values.assigned) statusFilters.push("'AS'");
                  if (values.scheduled) statusFilters.push("'SH'");
                  if (values.inprogress) statusFilters.push("'I'");
                  if (values.completed) statusFilters.push("'C'");
                  if (values.approved) statusFilters.push("'AP'");
                  if (values.query) statusFilters.push("'RJ'");

                  if (statusFilters.length > 0)
                    conditions.push(`FilterStatus IN (${statusFilters.join(",")})`);

                  const sourceFilters = [];
                  if (values.Teacher) sourceFilters.push("'Teacher'");
                  // if (values.self) sourceFilters.push("'Self'");
                  // if (values.manager) sourceFilters.push("'Manager'");
                  // if (values.sprint) sourceFilters.push("'Sprint'");
                  if (sourceFilters.length > 0)
                    conditions.push(`TaskSource IN (${sourceFilters.join(", ")})`);

                  if (values.project && values.project.length > 0) {
                    const projectIDs = values.project
                      .map((p) => `'${p.RecordID}'`)
                      .join(",");
                    conditions.push(`ProjectID IN (${projectIDs})`);
                  }



                  conditions.push(`CompanyID='${companyID}'`);
                  let whereClause = conditions.join(" AND ");
                  if (values.Milestone.length > 0) {
                    whereClause += ` AND MilestoneID IN(${values.Milestone
                      .map((val) => `'${val.RecordID}'`)
                      .join(",")})`;
                  }
                  if (values.TaskType && values.TaskType.length > 0) {
                    const TaskCodes = values.TaskType.join("','");
                    whereClause += ` AND FilterTaskType IN ('${TaskCodes}')`;
                  }

                  dispatch(fetchListview(accessID, screenName, whereClause, "", companyID));
                  setTimeout(() => setSubmitting(false), 100);
                }}
              // onReset={(values, { setFieldValue }) => handleResetFilters(setFieldValue)}
              >

                {({
                  values,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  handleBlur,
                  handleChange
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Box sx={{ height: 600, overflowY: "auto" }}>
                      <IconButton
                        size="small"
                        onClick={() => setShowMore(false)}
                        sx={{ position: "absolute", top: 5, right: 4 }}
                      >
                        <Tooltip title="Close">
                          <CancelIcon color="error" />
                        </Tooltip>
                      </IconButton>
                      <MultiFormikOptimizedAutocomplete
                        sx={{ width: 250, mt: 2 }}
                        name="project"
                        label="Standard"
                        id="project"
                        value={values.project}
                        onChange={(e, newValue) => {
                          setFieldValue("project", newValue);
                          console.log(newValue, "--newValue");
                          sessionStorage.setItem("TR354_project", JSON.stringify(newValue || []));
                          setFieldValue("Milestone", []);
                        }}
                        url={`${listViewurl}?data=${encodeURIComponent(
                          JSON.stringify({
                            Query: {
                              AccessID: "2114",
                              ScreenName: "Project",
                              Filter: `parentID=${companyID} AND EmployeeID=${EMPID}`,
                              Any: "",
                            },
                          })
                        )}`}
                      />
                      {/* <MultiFormikOptimizedAutocomplete
                        sx={{ width: "100%", mt: 2 }}
                        name="Milestone"
                        label="Section"
                        id="Milestone"
                        value={values.Milestone}
                        onChange={(e, newValue) =>{
                          setFieldValue("Milestone", newValue);
                          sessionStorage.setItem("TR354_Milestone", JSON.stringify(newValue || []));

                        }}
                        url={`${listViewurl}?data=${encodeURIComponent(
                          JSON.stringify({
                            Query: {
                              AccessID: "2105",
                              ScreenName: "Milestone",
                               Filter: `${
          values.project && values.project.length > 0
            ? `parentID IN (${values.project
                .map((p) => `'${p.RecordID}'`)
                .join(",")})`
            : "1=1"
        } AND CompanyID='${companyID}'`,
                              // Filter: `parentID=(${values.project?.RecordID}) AND CompanyID='${companyID}'`,
                              Any: "",
                            },
                          }),
                        )}`}
                      /> */}
                      <TextField
                        name="fromdate"
                        type="date"
                        id="fromdate"
                        label="From Date"
                        variant="standard"
                        value={values.fromdate || ""}
                        onChange={(e) => {
                          const newDate = e.target.value;
                          setFieldValue("fromdate", newDate);
                          dispatch(setFromDate(newDate));
                          sessionStorage.setItem("FromDate", newDate);
                        }}
                        focused
                        InputLabelProps={{ shrink: true }}
                        // inputProps={{ max: new Date().toISOString().split("T")[0] }}
                        sx={{ width: 250, mt: 2 }}
                      />

                      <TextField
                        name="date"
                        type="date"
                        id="date"
                        label="To Date"
                        variant="standard"
                        value={values.date || ""}
                        onChange={(e) => {
                          const newDate = e.target.value;
                          setFieldValue("date", newDate);
                          dispatch(setToDate(newDate));
                          sessionStorage.setItem("ToDate", newDate);
                        }}
                        focused
                        InputLabelProps={{ shrink: true }}
                        // inputProps={{ max: new Date().toISOString().split("T")[0] }}
                        sx={{ width: 250, mt: 2 }}
                      />

                      {isManager == 1 && accessID === "TR354" && (
                        <Employeeautocomplete
                          sx={{ width: 250, mt: 2 }}
                          name="empName"
                          label="Student"
                          id="empName"
                          value={selectedEmp}
                          onChange={(newValue) => {
                            if (newValue) {
                              setSelectedEmp(newValue);
                              const EmpId = newValue.RecordID;
                              dispatch(setEmployeeID(EmpId));
                              sessionStorage.setItem("EmployeeID", EmpId);
                              sessionStorage.setItem("EmployeeName", newValue.Name);
                            } else {
                              setSelectedEmp(null);
                              sessionStorage.removeItem("EmployeeID");
                              sessionStorage.removeItem("EmployeeName");
                              dispatch(setEmployeeID(""));
                            }
                          }}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2101","ScreenName":"EMPLOYEETEAMS","Filter":"parentID=${EMPID}","Any":"","CompId":${companyID}}}`}
                        />
                      )}

                      <FormControl variant="standard" sx={{ width: 250, mt: 2 }} focused>
                        <InputLabel id="TaskType-label">Task Type</InputLabel>

                        <Select
                          labelId="TaskType-label"
                          id="TaskType"
                          name="TaskType"
                          multiple
                          value={Array.isArray(values.TaskType) ? values.TaskType : []}
                          onChange={(e) => {
                            const selectedValues = e.target.value;

                            handleChange({
                              target: {
                                name: "TaskType",
                                value: selectedValues
                              }
                            });

                            sessionStorage.setItem(
                              "TR354_TaskType",
                              JSON.stringify(selectedValues)
                            );
                          }}
                          onBlur={handleBlur}
                          renderValue={(selected) =>
                            selected.map((value) => taskTypeLabels[value]).join(", ")
                          }
                        >
                          <MenuItem value="H">Homework</MenuItem>
                          <MenuItem value="P">Time Table</MenuItem>
                        </Select>
                      </FormControl>

                      <Typography mt={2} fontWeight="bold" color="error">
                        Status
                      </Typography>
                      {[
                        "assigned",
                        "scheduled",
                        "inprogress",
                        "completed",
                        "approved",
                        "query",
                      ].map((field) => (
                        <FormControlLabel
                          key={field}
                          control={
                            <Checkbox
                              name={field}
                              checked={values[field] || false}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                setFieldValue(field, checked);
                                sessionStorage.setItem(`TR354_${field}`, checked ? "Y" : "N");
                              }}
                            />
                          }
                          label={
                            field === "inprogress"
                              ? "In Progress"
                              : field.charAt(0).toUpperCase() + field.slice(1)
                          }
                        />
                      ))}

                      <Typography mt={2} fontWeight="bold" color="error">
                        Task Source
                      </Typography>
                      {["Teacher"].map((field) => (
                        <FormControlLabel
                          key={field}
                          control={
                            <Checkbox
                              name={field}
                              checked={values[field] || false}
                              onChange={(e) => setFieldValue(field, e.target.checked)}
                            />
                          }
                          label={field.charAt(0).toUpperCase() + field.slice(1)}
                        />
                      ))}

                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="end"
                        spacing={1}
                        mt={2}
                      >
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Apply
                        </Button>
                        <Button
                          variant="contained"
                          color="error"
                          onClick={() => handleResetFiltersTR354(setFieldValue)}
                        >
                          Reset
                        </Button>
                      </Stack>
                    </Box>
                  </form>
                )}
              </Formik>
            </Box>
          )}

        </Box>
        {/* <Box display="flex" alignItems="center" marginLeft={3}  >
          <Typography fontWeight={600} fontSize={15} lineHeight={1}
            mb={-2} >
            Action Guide
          </Typography></Box> */}
        {(accessID !== "TR394") && (accessID !== "TR218") && (
          <Box display="flex" alignItems="center" marginLeft={3}>
            <Typography fontWeight={600} fontSize={15} lineHeight={1} mb={-2}>
              Action Guide
            </Typography>
          </Box>
        )}
        {accessID == "TR049" ? (
          <Box display="flex" flexDirection="row" padding="25px">
            <Chip
              icon={<ListAltOutlinedIcon color="primary" />}
              label="List of UOM"
              variant="outlined"
            />
          </Box>
        ) : accessID == "TR381" ? (
          <Box display="flex" flexDirection="row" padding="25px" gap={1}>

            <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            />
            <Chip
              icon={<PictureAsPdfIcon color="error" />}
              label="Download Payslip Pdf"
              variant="outlined"
            />
          </Box>
        ) : accessID == "TR218" ? (null)
          : accessID == "TR392" ? (
            <Box display="flex" flexDirection="row" padding="25px">
              <Chip
                icon={<CurrencyRupeeOutlinedIcon color="primary" />}
                label="Payment"
                variant="outlined"
              />
            </Box>
          ) : accessID == "TR072" ? (
            <Box display="flex" flexDirection="row" padding="25px">
              <Chip
                icon={<ListAltOutlinedIcon color="primary" />}
                label="List Of Process"
                variant="outlined"
              />
            </Box>
          ) : accessID == "TR365" ? (
            <Box display="flex" flexDirection="row" padding="25px" gap={1}>
              <Chip
                icon={<ModeEditOutlinedIcon color="primary" />}
                label="Edit"
                variant="outlined"
              />

            </Box>
          ) : accessID == "TR333" ? (
            <Box display="flex" flexDirection="row" padding="25px" gap={1}>
              <Chip
                icon={<PictureAsPdfIcon color="" />}
                label="Download Payslip Pdf"
                variant="outlined"
              />
              <Chip
                icon={<PictureAsPdfIcon color="error" />}
                label="Download Payslip Pdf"
                variant="outlined"
              />

            </Box>
          ) : accessID == "TR331" ? (
            <Box display="flex" flexDirection="row" padding="25px">
              {/* <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            /> */}
              <Chip
                icon={<CurrencyRupeeOutlinedIcon color="primary" />}
                label="Payment"
                variant="outlined"
              // sx={{ marginLeft: "50px" }}
              />
            </Box>
          ) : accessID == "TR366" ? (
            <Box display="flex" flexDirection="row" padding="25px">
              {/* <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            /> */}
              <Chip
                icon={<CurrencyRupeeOutlinedIcon color="primary" />}
                label="Payment"
                variant="outlined"
              // sx={{ marginLeft: "50px" }}
              />
            </Box>
          ) : //LIST OF ASSESSMENT TYPE
            accessID == "TR308" ? (
              <Box display="flex" flexDirection="row" padding="25px" gap={2}>
                <Chip
                  icon={<Psychology color="primary" />}
                  label="Assessment"
                  variant="outlined"
                />
                {ManagerEmpIDCS && EMP_TRAINBY === "Y" && (
                  <Chip
                    icon={<RateReviewOutlinedIcon color="primary" />}
                    label="Evaluation"
                    variant="outlined"
                  />)}
              </Box>
            ) : //LIST OF ASSESSMENT
              accessID == "TR290" ? (
                <Box display="flex" flexDirection="row" padding="25px" gap={2}>
                  <Chip
                    icon={<FileUploadOutlinedIcon color="primary" />}
                    label="Story Board"
                    variant="outlined"
                  />

                  <Chip
                    icon={<AccessTimeIcon color="primary" />}
                    label="Session"
                    variant="outlined"
                  />
                  {/* <Chip
              icon={<AssessmentIcon color="error" />}
              label="Start Assessment"
              variant="outlined"
            /> */}
                  <Chip
                    icon={<QuizIcon color="error" />}
                    label="Start Assessment"
                    variant="outlined"
                  />

                  {/* <Chip
              icon={<DashboardIcon color="error" />}
              label="View Dashboard"
              variant="outlined"
            /> */}
                  <Chip
                    icon={<AnalyticsIcon color="secondary" />}
                    label="View Scoreboard"
                    variant="outlined"
                  />
                  <Chip
                    icon={<CachedOutlinedIcon color="error" />}
                    label="In Progress"
                    variant="outlined"
                  />
                  <Chip
                    icon={<DashboardIcon color="secondary" />}
                    label="View Appraisal Scoreboard"
                    variant="outlined"
                  />
                </Box>
              ) : //Scrum Task
                accessID == "TR132" || accessID == "TR354" ? (
                  <Box
                    display="flex"
                    flexDirection="row"
                    gap={1}
                    padding="25px"
                    flexWrap="wrap"
                    sx={{ overflowY: "auto" }}
                  >
                    <Chip
                      icon={<ModeEditOutlinedIcon color="primary" />}
                      label="Edit"
                      variant="outlined"
                    />

                    <Chip
                      icon={<VisibilityIcon color="primary" />}
                      label="View"
                      variant="outlined"
                    />

                    <Chip
                      icon={<AssignmentTurnedInIcon color="success" />}
                      label="Completed"
                      variant="outlined"
                    />

                    {/* <Chip
                icon={<EscalatorWarningIcon color="primary" />}
                label="Dependency"
                variant="outlined"
              /> */}
                    <Chip
                      icon={<UndoIcon color="info" />}
                      label="Transfer In"
                      variant="outlined"
                    />
                    <Chip
                      icon={<RedoIcon color="warning" />}
                      label="Transfer Out"
                      variant="outlined"
                    />
                    <Chip
                      icon={<BlockIcon color="primary" />}
                      label="Blocked"
                      variant="outlined"
                    />
                    <Chip
                      icon={<DoneOutlineIcon color="primary" />}
                      label="Pick Now"
                      variant="outlined"
                    />
                    <Chip
                      icon={<LockResetIcon color="primary" />}
                      label="Unblocked"
                      variant="outlined"
                    />
                    <Chip
                      icon={<AttachFileIcon color="primary" />}
                      label="Attachment"
                      variant="outlined"
                    />
                    <Chip
                      icon={<PictureAsPdfIcon color="error" />}
                      label="Generate & View PDF"
                      variant="outlined"
                    />
                  </Box>
                ) : accessID == "TR266" ? (
                  <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                    <Chip
                      icon={<ModeEditOutlinedIcon color="primary" />}
                      label="Edit"
                      variant="outlined"
                    />
                    <Chip
                      icon={<AttachFileIcon color="primary" />}
                      label="Attachment"
                      variant="outlined"
                    />
                  </Box>
                ) : accessID == "TR391" ? (
                  <Box display="flex" flexDirection="row" padding="25px" gap={2}>
                    <Chip
                      icon={<ModeEditOutlinedIcon color="primary" />}
                      label="Edit"
                      variant="outlined"
                    />
                    <Chip
                      icon={<VisibilityIcon color="primary" />}
                      label="View"
                      variant="outlined"
                    />
                  </Box>
                ) : accessID == "TR208" ? (
                  <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                    <Chip
                      icon={<ModeEditOutlinedIcon color="primary" />}
                      label="Edit"
                      variant="outlined"
                    />
                    <Chip
                      icon={<AttachFileIcon color="primary" />}
                      label="Attachment"
                      variant="outlined"
                    />
                  </Box>
                ) : accessID == "TR160" ? (
                  <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                    <Chip
                      icon={<ModeEditOutlinedIcon color="primary" />}
                      label="Edit"
                      variant="outlined"
                    />
                    <Chip
                      icon={<AttachFileIcon color="primary" />}
                      label="Attachment"
                      variant="outlined"
                    />
                  </Box>
                ) : accessID == "TR242" ? (
                  <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                    <Chip
                      icon={<ModeEditOutlinedIcon color="primary" />}
                      label="Edit"
                      variant="outlined"
                    />
                    <Chip
                      icon={<AttachFileIcon color="primary" />}
                      label="Attachment"
                      variant="outlined"
                    />
                  </Box>
                ) : accessID == "TR216" ? (
                  <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                    <Chip
                      icon={<ModeEditOutlinedIcon color="primary" />}
                      label="Edit"
                      variant="outlined"
                    />
                    <Chip
                      icon={<AttachFileIcon color="primary" />}
                      label="Attachment"
                      variant="outlined"
                    />
                  </Box>
                ) : accessID == "TR219" ? (
                  <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                    <Chip
                      icon={<ModeEditOutlinedIcon color="primary" />}
                      label="Edit"
                      variant="outlined"
                    />
                    <Chip
                      icon={<AttachFileIcon color="primary" />}
                      label="Attachment"
                      variant="outlined"
                    />
                  </Box>
                ) : // accessID == "TR245" ? (
                  //   <Box
                  //     display="flex"
                  //     flexDirection="row"
                  //     gap={1}
                  //     padding="25px"
                  //     sx={{ overflowY: "auto" }}
                  //   >
                  //     <Chip
                  //       icon={<ListAltOutlinedIcon color="primary" />}
                  //       label="Leave"
                  //       variant="outlined"
                  //     />
                  //     <Chip
                  //       icon={<ListAltOutlinedIcon color="primary" />}
                  //       label="Onduty"
                  //       variant="outlined"
                  //     />
                  //     <Chip
                  //       icon={<ListAltOutlinedIcon color="primary" />}
                  //       label="Overtime"
                  //       variant="outlined"
                  //     />
                  //      <Chip
                  //       icon={<ContactSupportIcon color="primary" />}
                  //       label="Overtime"
                  //       variant="outlined"
                  //     />
                  //     <Chip
                  //       icon={<ListAltOutlinedIcon color="primary" />}
                  //       label="Employee"
                  //       variant="outlined"
                  //     />
                  //   </Box>
                  accessID == "TR058" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="List of Remarks"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR010" ? (
                    <Box
                      display="flex"
                      flexDirection="row"
                      padding="25px"
                      sx={{ overflowY: "auto" }}
                    >
                      <Chip
                        icon={<ModeEditOutlinedIcon color="primary" />}
                        label="Edit"
                        variant="outlined"
                      />
                      <Chip
                        icon={<WysiwygIcon color="primary" />}
                        label="Customer Products"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<AssessmentIcon color="primary" />}
                        label="Customer Analysis"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<AddPhotoAlternateIcon color="primary" />}
                        label="Image Upload"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                    </Box>
                  ) : accessID == "TR009" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<EditIcon color="primary" />}
                        label="Edit"
                        variant="outlined"
                      />
                      <Chip
                        icon={<AddPhotoAlternateIcon color="primary" />}
                        label="Image Upload"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                    </Box>
                    // ) : accessID == "TR264" ? (
                  ) : accessID == "TR293" ? (
                    <Box display="flex" flexDirection="row" padding="15px" marginTop={2}>
                      <Chip
                        icon={<DoneIcon color="primary" />}
                        label="Approve"
                        variant="outlined"
                      />
                      <Chip
                        icon={<ContactSupportIcon color="primary" />}
                        label="Query"
                        variant="outlined"
                        sx={{ marginLeft: "20px" }}
                      />
                      <Chip
                        icon={<VisibilityIcon color="primary" />}
                        label="View"
                        variant="outlined"
                        sx={{ marginLeft: "20px" }}
                      />
                    </Box>
                  ) : accessID == "TR083" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="List of Colors"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR002" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ModeEditOutlinedIcon color="primary" />}
                        label="Edit"
                        variant="outlined"
                      />
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="Products"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<AddPhotoAlternateIcon color="primary" />}
                        label="Image Upload"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                    </Box>
                  ) : accessID == "TR044" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label=" List of Category"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR064" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="List of Stock"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR059" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="List of Delivery Challan"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR078" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="Edit"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR047" ? (
                    <Box
                      display="flex"
                      flexDirection="row"
                      padding="25px"
                      sx={{ overflowY: "auto" }}
                    >
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="Production Card Items"
                        variant="outlined"
                      />
                      <Chip
                        icon={<ListAltOutlinedIcon color="error" />}
                        label="Indent Items"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<PrintOutlinedIcon color="primary" />}
                        label="Print"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<SettingsBackupRestoreIcon color="primary" />}
                        label="Process"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<EmailIcon color="primary" />}
                        label="Email"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<PlayCircleOutlineOutlinedIcon color="success" />}
                        label="Not yet Started"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<NotStartedOutlinedIcon color="primary" />}
                        label="Inprogress"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<TaskAltOutlinedIcon color="success" />}
                        label="Completed"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<PauseCircleOutlinedIcon color="warning" />}
                        label="Pause"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                    </Box>
                  ) : accessID == "TR076" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="List of Batch"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR116" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="Packing List"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR109" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ModeEditOutlinedIcon color="primary" />}
                        label="Edit"
                        variant="outlined"
                      />
                      <Chip
                        icon={<PrintOutlinedIcon color="primary" />}
                        label="Print"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                      <Chip
                        icon={<EmailIcon color="primary" />}
                        label="Email"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                    </Box>
                  ) : accessID == "TR043" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="List of Invoice"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR101" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="Order Enquiry"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR027" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ModeEditOutlinedIcon color="primary" />}
                        label="Edit"
                        variant="outlined"
                      />

                      <Chip
                        icon={<AddPhotoAlternateIcon color="primary" />}
                        label="Image Upload"
                        variant="outlined"
                        sx={{ marginLeft: "50px" }}
                      />
                    </Box>
                  ) : accessID == "TR133" ? (
                    <Box display="flex" flexDirection="row" padding="25px" gap={2}>


                      {!is003Subscription ? (
                        <>
                          <Chip
                            icon={<BalanceIcon color="primary" />}
                            label="Milestone Weightage"
                            variant="outlined"
                          />
                          {/* <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            /> */}
                          <Chip
                            icon={<FlagIcon color="primary" />}
                            label={is003Subscription ? "List of Section" : "List of Milestone"}
                            variant="outlined"
                          />
                          {/* <Chip
              icon={<TaskAltIcon  color="primary" />}
              label="Sprint"
              variant="outlined"
            /> */}

                        </>
                      ) : (
                        <Chip
                          icon={<DatasetLinkedIcon color="primary" />}
                          label="Time Table"
                          variant="outlined"
                        />
                      )}
                      <Chip
                        icon={<PeopleAltIcon color="primary" />}
                        // label="Team Project"
                        label={is003Subscription ? "Class Teachers And Students" : "Team Project"}
                        variant="outlined"
                      />
                      {is002Subscription &&
                        (

                          <Chip
                            icon={<AssignmentIndOutlinedIcon color="primary" />}
                            // label={"Effort Allocation"}
                            label={"RVA"}
                            variant="outlined"
                          />
                        )}
                    </Box>
                  ) : accessID == "TR269" ? (
                    <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                      {/* <Chip
              icon={<ModeEditOutlinedIcon color="primary" />}
              label="Edit"
              variant="outlined"
            />
            */}
                      <Chip
                        icon={<TaskAltIcon color="primary" />}
                        label="Sprint"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR276" ? (
                    <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                      <Chip
                        icon={<ModeEditOutlinedIcon color="primary" />}
                        label="Edit"
                        variant="outlined"
                      />

                      <Chip
                        icon={<TransferWithinAStationIcon color="primary" />}
                        label="Routine Tasks"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR123" ? (
                    <Box display="flex" flexDirection="row" padding="25px" gap="5px">
                      <Chip
                        icon={<ModeEditOutlinedIcon color="primary" />}
                        label="Edit"
                        variant="outlined"
                      />
                      <Chip
                        icon={<TodayIcon color="primary" />}
                        label="Scrum Task"
                        variant="outlined"
                      />
                    </Box>
                  ) : accessID == "TR099" ? (
                    <Box display="flex" flexDirection="row" padding="25px">
                      <Chip
                        icon={<ListAltOutlinedIcon color="primary" />}
                        label="List of Usergroups"
                        variant="outlined"
                      />
                    </Box>
                  ) : (
                    accessID !== "TR392" && accessID !== "TR394" ? (
                      <Box display="flex" flexDirection="row" padding="25px">
                        <Chip
                          icon={<EditIcon color="primary" />}
                          label="Edit"
                          variant="outlined"
                        />
                      </Box>
                    ) : null
                  )}


      </Box>

      {/* <MatxCustomizer open={open}screenName={invoice} rowData={mailData} type={""} /> */}
    </React.Fragment>
  );
};
export default Listview;
